import { render, staticRenderFns } from "./costHelpSixtyTage.vue?vue&type=template&id=95cd79d6&"
import script from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95cd79d6')) {
      api.createRecord('95cd79d6', component.options)
    } else {
      api.reload('95cd79d6', component.options)
    }
    module.hot.accept("./costHelpSixtyTage.vue?vue&type=template&id=95cd79d6&", function () {
      api.rerender('95cd79d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2034hybaXvbML/JS/costHelpSixtyTage.vue"
export default component.exports